import { render, staticRenderFns } from "./dataCollectionMonitoring.vue?vue&type=template&id=0e77c680&scoped=true"
import script from "./dataCollectionMonitoring.vue?vue&type=script&lang=js"
export * from "./dataCollectionMonitoring.vue?vue&type=script&lang=js"
import style0 from "./dataCollectionMonitoring.vue?vue&type=style&index=0&id=0e77c680&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e77c680",
  null
  
)

export default component.exports